
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("imx7a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "JqlUtils", () => $caaf627a559c23ab$export$2837dbdb4d803576);
$parcel$export(module.exports, "useJqlUtils", () => $caaf627a559c23ab$export$c7c2706ff288264f);
$parcel$export(module.exports, "default", () => $caaf627a559c23ab$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9qsUT = parcelRequire("9qsUT");

var $5mnOo = parcelRequire("5mnOo");

var $8Wvo9 = parcelRequire("8Wvo9");

var $ldnzD = parcelRequire("ldnzD");

var $bZvz7 = parcelRequire("bZvz7");

var $hctxN = parcelRequire("hctxN");
class $caaf627a559c23ab$export$2837dbdb4d803576 {
    jql(newJqlString) {
        const newJast = new (0, $9qsUT.JastBuilder)().build(newJqlString);
        if (newJast.errors.length && this.jast) return this;
        this.jast = newJast;
        this.jqlString = newJqlString;
        return this;
    }
    ast(ast) {
        this.jast = ast;
        this.jqlString = ast.represents;
        return this;
    }
    setPrimarySortField(sortField, sortDirection, aliases) {
        if (!this.jast) return this;
        return this.jql((0, $hctxN.setPrimarySortField)(this.jast, sortField, sortDirection, aliases));
    }
    setPrimarySortDirection(sortOrder) {
        if (!this.jast) return this;
        return this.jql((0, $bZvz7.setPrimarySortDirection)(sortOrder, this.jast));
    }
    getPrimarySortField() {
        if (!this.jast) return undefined;
        return (0, $ldnzD.getPrimarySortField)(this.jast);
    }
    getPrimarySortDirection() {
        if (!this.jast) return undefined;
        return (0, $8Wvo9.getPrimarySortDirection)(this.jast);
    }
    getOrderBy() {
        if (!this.jast) return undefined;
        return (0, $5mnOo.getOrderBy)(this.jast);
    }
    toJql() {
        return this.jqlString;
    }
    constructor(){
        this.jast = undefined;
        this.jqlString = undefined;
    }
}
const $caaf627a559c23ab$export$c7c2706ff288264f = ()=>{
    return (0, $eJOHy.useState)(()=>new $caaf627a559c23ab$export$2837dbdb4d803576())[0];
};
var $caaf627a559c23ab$export$2e2bcd8739ae039 = $caaf627a559c23ab$export$c7c2706ff288264f;

});
parcelRegister("5mnOo", function(module, exports) {
$parcel$export(module.exports, "getOrderBy", () => $9b612bf9f8a48fca$export$128f09144c413f07);

var $etRm8 = parcelRequire("etRm8");
const $9b612bf9f8a48fca$export$128f09144c413f07 = (jast)=>{
    const jqlString = jast.represents;
    const orderBy = jast.query?.orderBy;
    if (orderBy && orderBy.position) return (0, $etRm8.substring)(jqlString, orderBy.position[0], orderBy.position[1]);
    return undefined;
};

});
parcelRegister("etRm8", function(module, exports) {
$parcel$export(module.exports, "substring", () => $a6ff7d96722f4e2e$export$662d3818631fba36);
/**
 * Returns the substring at the specified location within a String object while supporting Emojis.
 *
 * This method is to be used instead of String.substring. String.substring does not handle emojis correctly as they can be multi-char length.
 *
 * @param start — The zero-based index number indicating the beginning of the substring.
 * @param end Zero-based index number indicating the end of the substring. The substring includes the characters up to, but not including, the character indicated by end. If end is omitted, the characters from start through the end of the original string are returned.
 */ const $a6ff7d96722f4e2e$export$662d3818631fba36 = (str, start, end)=>[
        ...str
    ].slice(start, end).join('');

});


parcelRegister("8Wvo9", function(module, exports) {
$parcel$export(module.exports, "getPrimarySortDirection", () => $40e860ffab225445$export$ede1a70fd138682b);
const $40e860ffab225445$export$ede1a70fd138682b = (jast)=>jast.query?.orderBy?.fields[0]?.direction?.value;

});

parcelRegister("ldnzD", function(module, exports) {
$parcel$export(module.exports, "getPrimarySortField", () => $115804e04deae173$export$2281286922a00968);

var $etRm8 = parcelRequire("etRm8");
const $115804e04deae173$export$2281286922a00968 = (jast)=>{
    const primarySortField = jast.query?.orderBy?.fields[0];
    return primarySortField?.field.properties && primarySortField?.field?.position ? (0, $etRm8.substring)(jast.represents, primarySortField?.field?.position[0], primarySortField?.field?.position[1]) : primarySortField?.field.value;
};

});

parcelRegister("bZvz7", function(module, exports) {
$parcel$export(module.exports, "setPrimarySortDirection", () => $ca2eb1fe794f29a4$export$aec8b488d3f81589);

var $etRm8 = parcelRequire("etRm8");
const $ca2eb1fe794f29a4$export$aec8b488d3f81589 = (sortOrder, jast)=>{
    const jql = jast.represents;
    const orderBy = jast.query?.orderBy;
    if (typeof jql !== 'string') return '';
    if (!orderBy || !orderBy.fields.length) return jql;
    const { direction: direction } = orderBy.fields[0];
    if (!direction && orderBy.fields.length > 1) {
        const { field: field } = orderBy.fields[0];
        if (!field.position) return jql;
        const [, end] = field.position;
        return `${(0, $etRm8.substring)(jql, 0, end)} ${sortOrder}${(0, $etRm8.substring)(jql, end)}`;
    }
    if (!direction) return `${jql} ${sortOrder}`;
    if (!direction.position) return jql;
    const [start, end] = direction.position;
    return `${(0, $etRm8.substring)(jql, 0, start)}${sortOrder}${(0, $etRm8.substring)(jql, end)}`;
};

});

parcelRegister("hctxN", function(module, exports) {
$parcel$export(module.exports, "setPrimarySortField", () => $46ddad71f22c829a$export$e66898f5eaced7d6);

var $f26C8 = parcelRequire("f26C8");
var $1jiqw = parcelRequire("1jiqw");

var $4cTDP = parcelRequire("4cTDP");

var $etRm8 = parcelRequire("etRm8");

var $cVkGk = parcelRequire("cVkGk");
const $46ddad71f22c829a$export$e66898f5eaced7d6 = (jast, sortField, sortDirection = (0, $adec16a85d57f51f$export$2ea27ea5f2121899), aliases)=>{
    const orderBy = jast.query?.orderBy;
    const jql = jast.represents;
    // #region New implementation with JQL AST refactor
    if ((0, $4cTDP.fg)('jsc_list_reranking_ast_refactor')) {
        // If the sortDirection provided is 'NONE', the sortField should be removed and not added.
        const orderByDirection = sortDirection === 'ASC' || sortDirection === 'DESC' ? sortDirection : undefined;
        // Add order by clause if it doesn't exist
        if (!orderBy || !orderBy.fields.length) {
            // sortField is only prepended if a valid orderByDirection is provided
            orderByDirection && jast.query?.prependOrderField((0, $f26C8.default).orderByField((0, $f26C8.default).field(sortField), (0, $f26C8.default).orderByDirection(orderByDirection)));
            return (0, $1jiqw.print)(jast);
        }
        let currentSortField = sortField;
        const fieldAliases = new Set([
            (0, $cVkGk.sanitizeClauseName)(sortField).toLocaleLowerCase(),
            ...aliases
        ]);
        const visitedFields = new Set();
        // Filter out duplicate fields
        const filteredFields = orderBy.fields.filter((field)=>{
            const sanitizedFieldName = (0, $cVkGk.sanitizeClauseName)(field.field.value).toLocaleLowerCase();
            if (fieldAliases.has(sanitizedFieldName)) {
                currentSortField = field.field.value;
                return false;
            }
            if (visitedFields.has(sanitizedFieldName)) return false;
            visitedFields.add(field.field.value);
            return true;
        });
        // Remove orderBy clause if there are no fields left and no valid orderByDirection
        if (!filteredFields.length && !orderByDirection) {
            orderBy.remove();
            return (0, $1jiqw.print)(jast);
        }
        // Replace the orderBy clause with the updated fields
        orderBy.replace((0, $f26C8.default).orderBy(filteredFields));
        // sortField is only prepended if a valid orderByDirection is provided
        orderByDirection && jast.query?.prependOrderField((0, $f26C8.default).orderByField((0, $f26C8.default).field(currentSortField), (0, $f26C8.default).orderByDirection(orderByDirection)));
        return (0, $1jiqw.print)(jast);
    }
    // #region Legacy implementation with string manipulation
    if (!orderBy || !orderBy.fields.length) return sortDirection === 'NONE' && (0, $4cTDP.fg)('jsc_list_reranking_gate') ? jql : `${jql} ORDER BY ${sortField}${sortDirection ? ` ${sortDirection}` : ''}`;
    const includedFields = new Set([
        sortField,
        ...aliases
    ]);
    const sanitizedSortField = (0, $cVkGk.sanitizeClauseName)(sortField);
    const orderByFields = orderBy.fields;
    // Filter out duplicate fields based on their value in the JQL
    const filteredFields = orderByFields.filter((field)=>{
        const { position: position } = field.field;
        const fieldValue = field.field.properties && position ? (0, $etRm8.substring)(jql, position[0], position[1]) : field.field.value;
        if (includedFields.has(fieldValue)) return false;
        includedFields.add(fieldValue);
        return true;
    });
    // remove order by clause if there are no fields left
    if (!filteredFields.length && sortDirection === 'NONE' && (0, $4cTDP.fg)('jsc_list_reranking_gate')) {
        orderBy.remove();
        return (0, $1jiqw.print)(jast);
    }
    // Convert fields to JQL
    const fieldsJql = filteredFields.reduce((acc, field)=>{
        const { position: position } = field;
        if (position) acc.push((0, $etRm8.substring)(jql, position[0], position[1]));
        return acc;
    }, !(0, $4cTDP.fg)('jsc_list_reranking_gate') || sortDirection !== 'NONE' ? [
        `${sanitizedSortField} ${sortDirection}`
    ] : []).join(', ');
    const startPosition = orderBy.fields[0].position;
    if (startPosition) {
        const start = startPosition[0];
        return `${(0, $etRm8.substring)(jql, 0, start)}${fieldsJql}`;
    }
    return jql;
};

});
const $adec16a85d57f51f$export$ca51f5fd60a74517 = 'ORDER BY';
const $adec16a85d57f51f$export$6d60017b9e092e73 = 'ASC';
const $adec16a85d57f51f$export$2ea27ea5f2121899 = 'DESC';

parcelRegister("cVkGk", function(module, exports) {
$parcel$export(module.exports, "sanitizeClauseName", () => $af2448e603ef5f7b$export$5f3b8bbb2bff9817);

var $6PCNA = parcelRequire("6PCNA");

var $4cTDP = parcelRequire("4cTDP");

var $bJxG9 = parcelRequire("bJxG9");
// Check if string have inner spaces
const $af2448e603ef5f7b$var$haveSpaces = (s)=>/\s/g.test(s.trim());
// Mirrors sanitzation in JQL AST package
const $af2448e603ef5f7b$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($6PCNA)))('"\'=!<>()~,[]|&{}*/%+^$#@?;')}]`);
const $af2448e603ef5f7b$export$5f3b8bbb2bff9817 = (clauseName)=>{
    if ((0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? $af2448e603ef5f7b$var$CHARS_TO_QUOTE.test(clauseName.trim()) : $af2448e603ef5f7b$var$haveSpaces(clauseName)) return (0, $bJxG9.quoteString)(clauseName);
    return clauseName;
};

});
parcelRegister("bJxG9", function(module, exports) {
$parcel$export(module.exports, "quoteString", () => $05ac588acedf6aa5$export$2c4c4d2119dc396f);
/**
 * Wrap the provided string in double quotes and escape and double quote characters present in the string.
 */ const $05ac588acedf6aa5$export$2c4c4d2119dc396f = (str)=>`"${str.replace(/"/g, '\\"')}"`;

});





$parcel$global.rlb("h9R5C")
//# sourceMappingURL=async-jira-jql-utils.a772124f.js.map
